import angular from 'angular';
import toggleNotes from './toggleNotes';

export default angular
  .module('components.toggleNotes', [])
  .component('toggleNotes', toggleNotes).name;
